import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Shown after Azure AD admin consent succeeds. The backend has already recorded
 * the organization's tenant; users can now sign in.
 */
export function ConnectSuccessPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CheckCircle2 className="mx-auto mb-4 h-12 w-12 text-green-600" />
          <CardTitle className="text-xl">You&apos;re connected</CardTitle>
          <CardDescription>
            Microsoft 365 single sign-on is set up for your organization. Your team can now
            sign in to Metaonia with their work accounts.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <Link to="/login" className="text-sm text-primary underline">
            Continue to the HR Dashboard
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
